const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL?.trim() || '';
const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(supportEmail);

document.querySelectorAll('[data-support-email]').forEach(element => {
  if (!validEmail) return;
  const link = document.createElement('a');
  link.href = `mailto:${supportEmail}`;
  link.textContent = supportEmail;
  element.replaceChildren(link);
});
